import {produce} from 'immer'

import {useEffect} from 'react'
import {graphql, useFragment, useRelayEnvironment} from 'react-relay'
import {createOperationDescriptor, getRequest} from 'relay-runtime'

import {subscribeOnRunningBuild} from '../../utils/subscriber'

import type {useRunningBuildUpdaterRelayFragment$key} from './__generated__/useRunningBuildUpdaterRelayFragment.graphql'

const fragment = graphql`
  fragment useRunningBuildUpdaterRelayFragment on Build {
    id
    rawId
    state
  }
`

const query = graphql`
  query useRunningBuildUpdaterRelayQuery($locator: String!) {
    build(buildLocator: $locator) {
      buildTypeId
      number
      runningInfo {
        percentageComplete
        elapsedSeconds
        estimatedTotalSeconds
        leftSeconds
        currentStageText
        probablyHanging
        lastActivityTime
        outdated
        outdatedReasonBuild {
          number
          links {
            link {
              relativeUrl
            }
          }
        }
      }
      canceledInfo {
        timestamp
        text
        user {
          id
          rawId
          name
          username
        }
      }
      statusText
      status
      state
      detachedFromAgent
      finishOnAgentDate
      personal
      artifacts {
        count
      }
      testOccurrences {
        count
      }
      agent {
        connected
      }
    }
  }
`

export function useRunningBuildUpdaterRelay(key: useRunningBuildUpdaterRelayFragment$key | null) {
  const {id, rawId, state} = useFragment(fragment, key) ?? {}
  const environment = useRelayEnvironment()
  useEffect(
    () =>
      state === 'running' && rawId != null
        ? subscribeOnRunningBuild(rawId, data => {
            if (data != null) {
              environment.commitPayload(
                createOperationDescriptor(getRequest(query), {locator: `id:${rawId}`}),
                {
                  build: produce<any>(data, draft => {
                    draft.id = id
                    draft.runningInfo = draft['running-info']
                    delete draft['running-info']
                    if (draft.canceledInfo?.user?.id != null) {
                      draft.canceledInfo.user.rawId = draft.canceledInfo.user.id
                      draft.canceledInfo.user.id = `User:${draft.canceledInfo.user.id}`
                    }
                  }),
                },
              )
            }
          })
        : undefined,
    [environment, id, rawId, state],
  )
}
